import script from "./CustomDeckBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDeckBuilder.vue?vue&type=script&setup=true&lang=js"

import "./CustomDeckBuilder.vue?vue&type=style&index=0&id=0ce4d81e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce4d81e"]])

export default __exports__